import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import AlbumSearch from './AlbumSearch';

const AlbumSearchView = () => {
  return (
    <Fragment>
      <Helmet>
        <body className="wg-album-search" />
      </Helmet>

      <AlbumSearch />
    </Fragment>
  );
};

export default AlbumSearchView;
